import type { ComponentProps } from 'react';
import { OwcStep } from '@one/react';

export type PocStepProps = ComponentProps<typeof OwcStep>;

export const PocStep: React.FC<PocStepProps> = (props) => <OwcStep {...props} />;
